module.exports = __webpack_public_path__ + "img/shop4-1.1998e228.png";